import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Controls-Redio",
  "use": "icon-Controls-Redio-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"icon-Controls-Redio\"><rect x=\".5\" y=\".635\" width=\"15\" height=\"15\" rx=\"7.5\" stroke=\"#B2B6C0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol